import { gql } from '@apollo/client';

export const CORE_PROPERTY_FIELDS = gql`
    fragment CorePropertyFields on Property {
        id
        recordId
        title
        description
        subpremiseId
        url
        location
        lat
        lng
        streetNumber
        streetName
        city
        stateProvince
        zipCode
        country
        listingStatus
        purpose
        density
        size
        squareFeet
        typeOfCenter
        typeOfFacility
        createdAt
        updatedAt
        activatedAt
        expiresAt
        sitePlan {
            id
            recordId
            url
        }
        businesses {
            name
        }
        events {
            id
            recordId
            code
        }
        manager {
            id
            recordId
            prefix
            firstName
            middleName
            lastName
            suffix
            title
            photoUrl
            company {
                id
                recordId
                name
                addresses {
                    city
                    stateProvince
                    preferredMailing
                }
                primaryBusinessType {
                    name
                    code
                }
            }
        }
        photos {
            id
            recordId
            isCoverPhoto
            url
        }
    }
`;
